var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagBad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1176 11.9C10.1819 11.8997 10.2455 11.8853 10.3036 11.8578C10.3618 11.8303 10.4133 11.7903 10.4543 11.7407C10.4953 11.6911 10.5249 11.633 10.541 11.5707C10.5571 11.5084 10.5593 11.4433 10.5474 11.38C10.4275 10.7929 10.1085 10.2652 9.64429 9.88621C9.1801 9.50723 8.59925 9.30023 8 9.30023C7.40075 9.30023 6.8199 9.50723 6.35571 9.88621C5.89151 10.2652 5.57248 10.7929 5.45258 11.38C5.44061 11.4433 5.44273 11.5084 5.45879 11.5708C5.47485 11.6332 5.50445 11.6912 5.54548 11.7409C5.58652 11.7905 5.63798 11.8305 5.69622 11.858C5.75446 11.8855 5.81804 11.8998 5.88244 11.9H10.1176Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96667 4.96667L6.7 6.7H4.53333",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0333 4.96667L9.3 6.7H11.4667",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96667 4.96667L6.7 6.7H4.53333M11.0333 4.96667L9.3 6.7H11.4667M14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8ZM10.1176 11.9C10.1819 11.8997 10.2455 11.8853 10.3036 11.8578C10.3618 11.8303 10.4133 11.7903 10.4543 11.7407C10.4953 11.6911 10.5249 11.633 10.541 11.5707C10.5571 11.5084 10.5593 11.4433 10.5474 11.38C10.4275 10.7929 10.1085 10.2652 9.64429 9.88621C9.1801 9.50723 8.59925 9.30023 8 9.30023C7.40075 9.30023 6.8199 9.50723 6.35571 9.88621C5.89151 10.2652 5.57248 10.7929 5.45258 11.38C5.44061 11.4433 5.44273 11.5084 5.45879 11.5708C5.47485 11.6332 5.50445 11.6912 5.54548 11.7409C5.58652 11.7905 5.63798 11.8305 5.69622 11.858C5.75446 11.8855 5.81804 11.8998 5.88244 11.9H10.1176Z",
    stroke: "#AA10C1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBad);
export default __webpack_public_path__ + "static/media/flag-bad.b357d454105f577e4dd00c5b7f860481.svg";
export { ForwardRef as ReactComponent };